import Switch from '~/components/SwitchWithLabel';
import TextField from '~/components/TextField';
import TextFieldWithTooltip from '~/components/TextFieldWithTooltip';

import styles from './SharedSettings.style';
import Sidebar, {
  SidebarHeader,
  SidebarTitle,
  SidebarTypography,
} from './Sidebar';

class EmailSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: this.props.form,
      emailError: false,
    };
  }

  UNSAFE_componentWillReceiveProps({ form }) {
    if (form) {
      this.setState({ form });
    }
  }

  onChange = (attr, event) => {
    let form = Object.assign({}, this.state.form);
    form[attr] = event.target.value;
    this.setState({ form });
  };

  onBlur = () => {
    const { form } = this.state;

    if (this.validate(form)) {
      this.props.onUpdateForm(form);
    }
  };

  onToggle = (attr, event) => {
    let form = Object.assign({}, this.state.form);
    form[attr] = event.target.checked;

    if (this.validate(form)) {
      this.props.onUpdateForm(form);
    }
  };

  validate = (form) => {
    this.setState({ emailError: false });

    if (!form.email_enabled) return true;

    if (!/.@./.test(form.email)) {
      this.setState({ emailError: true });
      return false;
    }

    return true;
  };

  render() {
    const { classes } = this.props;
    const { form } = this.state;

    return (
      <div className={classes.root}>
        <Sidebar>
          <SidebarHeader>
            <SidebarTitle>Email settings</SidebarTitle>

            <Switch
              label="Enabled"
              checked={form.email_enabled}
              onChange={this.onToggle.bind(this, 'email_enabled')}
            />
          </SidebarHeader>

          <div className={classes.content}>
            <SidebarTypography>
              Get emailed every time someone submits a form.
            </SidebarTypography>

            <div className={classes.input}>
              <TextField
                fullWidth
                error={this.state.emailError}
                required
                name="Email"
                label="Email"
                type="text"
                value={form.email || ''}
                onChange={this.onChange.bind(this, 'email')}
                onBlur={this.onBlur.bind(this, 'email')}
              />
            </div>

            <TextFieldWithTooltip
              fullWidth
              name="Email Subject Template"
              labelValue="Email Subject Template"
              type="text"
              value={form.email_subject_template || ''}
              onChange={this.onChange.bind(this, 'email_subject_template')}
              onBlur={this.onBlur.bind(this, 'email_subject_template')}
              tooltipTitle="The template for generating the subject line we use when sending emails. Please see our docs for more info."
              tooltipPlacement="right"
              wrapperClassName={classes.input}
            />
          </div>
        </Sidebar>
      </div>
    );
  }
}

EmailSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onUpdateForm: PropTypes.func.isRequired,
};

export default withStyles(styles)(EmailSettings);
